var exports = {
  "k": "x93eb46d8--35761d--container",
};

module.exports = exports;
